module.exports = __webpack_public_path__ + "img/FC2.4d764130.svg";